const profile = "dev";

export default {
    profile,
};
